import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getEvents, removeEvents, toggleEvents } from 'slice/eventsSlice';
import AdminTable from 'common/AdminTable';
import { FaPlus } from 'react-icons/fa';

const getEventMediaUrl = (mediaPath) => {
    if (!mediaPath) return null;
    if (/^https?:\/\//i.test(mediaPath)) return mediaPath;
    const base = (process.env.REACT_APP_BACKEND || '').replace(/\/+$/, '');
    const normalized = String(mediaPath).replace(/^\/+/, '');
    if (normalized.startsWith('uploads/')) {
        return `${base}/${normalized}`;
    }
    return `${base}/uploads/${normalized}`;
};

const EventList = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const eventsState = useSelector((state) => state.events);
    const events = Array.isArray(eventsState?.data) ? eventsState.data : [];
    const loading = eventsState?.loading;

    const tableHeaders = [
        {
            Header: 'ID',
            accessor: 'id',
        },
        {
            Header: 'Heading',
            accessor: 'heading',
        },
        {
            Header: 'Sub Heading',
            accessor: 'sub_heading',
            Cell: ({ row }) => row.original.sub_heading || '-',
        },
        {
            Header: 'Image',
            accessor: 'image',
            Cell: ({ row }) => (
                <img
                    src={getEventMediaUrl(row.original.image)}
                    alt={row.original.heading}
                    className="banner-thumb"
                    onError={(e) => { e.target.style.display = 'none'; }}
                />
            ),
        },
        {
            Header: 'File',
            accessor: 'file',
            Cell: ({ row }) => row.original.file ? (
                <a
                    href={getEventMediaUrl(row.original.file)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-sm btn-outline-primary"
                >
                    View
                </a>
            ) : '-',
        },
        {
            Header: 'Status',
            accessor: 'is_active',
            Cell: ({ row }) => (
                <span className={`badge ${row.original.is_active ? 'badge-success' : 'badge-danger'}`}>
                    {row.original.is_active ? 'Active' : 'Inactive'}
                </span>
            )
        },
        {
            Header: 'Actions',
            accessor: 'actions',
            Cell: ({ row }) => (
                <div className="d-flex flex-wrap" style={{ gap: 6 }}>
                    <button
                        className="btn btn-sm btn-info"
                        onClick={() => navigate(`/events/update/${row.original.id}`)}
                    >
                        Edit
                    </button>
                    <button
                        className={`btn btn-sm ${row.original.is_active ? 'btn-warning' : 'btn-success'}`}
                        onClick={() => dispatch(toggleEvents(row.original.id))}
                    >
                        {row.original.is_active ? 'Deactivate' : 'Activate'}
                    </button>
                    <button
                        className="btn btn-sm btn-danger removebtn"
                        onClick={() => {
                            if (window.confirm('Are you sure you want to delete this event?')) {
                                dispatch(removeEvents(row.original.id));
                            }
                        }}
                    >
                        Remove
                    </button>
                </div>
            ),
        },
    ];

    useEffect(() => {
        dispatch(getEvents())
    }, [dispatch])

    return (
        <div className="container-fluid px-4">
            <div className="d-flex justify-content-between align-items-center my-4 flex-wrap" style={{ gap: '0.75rem' }}>
                <div>
                    <h2 className="m-0">Events</h2>
                    <small className="text-muted">Manage hospital events</small>
                </div>
                <button className="btn btn-primary" onClick={() => navigate('/events/add')}>
                    <FaPlus /> Add Event
                </button>
            </div>

            <div className="card shadow mb-4">
                <div className="card-body p-0">
                    {loading && events.length === 0 ? (
                        <div className="text-center p-5">Loading...</div>
                    ) : (
                        <AdminTable tableHeaders={tableHeaders} tableData={events} />
                    )}
                </div>
            </div>
        </div>
    )
}

export default EventList;
